import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import TopicCard from "@/components/feature/TopicCard";

export default function LatestReviews() {
  const [lead, ...rest] = topics;

  return (
    <section id="latest" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">
              时间线已梳理完成
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              最新事件复盘
            </h2>
          </div>
          <Link
            to="/topics"
            className="inline-flex w-fit items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            进入复盘列表
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <TopicCard topic={lead} variant="default" />
          </div>
          <div className="flex flex-col gap-4 lg:col-span-7">
            {rest.map((topic) => (
              <TopicCard key={topic.id} topic={topic} variant="horizontal" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}